import React, {forwardRef, useEffect, useMemo, useRef, useState} from "react";
import {
    BubbleMenu,
    EditorContent,
    EditorProvider, isMacOS, mergeAttributes,
    ReactNodeViewRenderer,
    useCurrentEditor,
    useEditor
} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {Export} from "@tiptap-pro/extension-export";
import RenderCustomTable from "../../../../../src/components/EditorV2/Table/RenderCustomTable";
import {TableRow} from "@tiptap/extension-table-row";
import {TableHeader} from "@tiptap/extension-table-header";
import CustomTableCell from "../../../../../src/components/EditorV2/TableCell/tableCell";
import {UniqueID} from "@tiptap-pro/extension-unique-id";
import Focus from "@tiptap/extension-focus";
import Gapcursor from "@tiptap/extension-gapcursor";
import Text from "@tiptap/extension-text";
import TextStyle from "@tiptap/extension-text-style";
import {Color} from "@tiptap/extension-color";
import Heading from "@tiptap/extension-heading";
import Paragraph from "@tiptap/extension-paragraph";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import {getBlockMenu} from "../../../../../src/components/EditorV2/BlockMenu/BlockMenu";
import Placeholder from "@tiptap/extension-placeholder";
import FontSize from "tiptap-extension-font-size";
import {Indent} from "../../../../../src/components/EditorV2/indent";
import ImageT from "@tiptap/extension-image";
import Image from "../../../../../src/components/EditorV2/imgResize";
import SearchNReplace from "../../../../../src/components/EditorV2/Search/plugin";
import {fileToBase64, ImagePaste} from "../../../../../src/components/EditorV2/ImagePaste";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "../../../../../src/components/EditorV2/task-item";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Blockquote from "@tiptap/extension-blockquote";
import {FontFamily} from "@tiptap/extension-font-family";
import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import CodeBlockComponent from "../../../../../src/components/EditorV2/CodeBlock3";
import {lowlight} from "lowlight";
import DeeplinkNode from "../../../../../src/components/Deeplink/DeeplinkNode";
import CodeInlie from '@tiptap/extension-code'
import {
    calcCardTitleHeight,
    calcTextAreaHeight,
    createCopyLink,
    decodeDeeplink, extFromMineType,
    firstLetterUpper, generateUUID2,
    getImagePathWithTheme, getIntValue, getYouTubeThumbnailUrl,
    imgPathPerfix, isDarkMode,
    isDeepLink, isDefaultBackgroundColor, isStringNullOrEmpty, migrateInlineCodeToOfficial, removeHtmlTags,
    replaceLatexInParagraph, sleep
} from "../../../../../src/utils";
import {
    CARD_MAX_PASTE_SIZE,
    DEFAULT_COLLAPSE_HEIGHT,
    DEFAULT_COLLAPSE_HEIGHT_1, DEFAULT_STICK_NOTE_HEIGHT,
    DEFAULT_TOOLBAR_HEIGHT, ELEMENT_POPOVER_TOOLS_OFFSET_Y,
    EVENT_ACTIVE_CARD_EDIT,
    EVENT_CANVAS_EXPAND_STATS_CHANGED,
    EVENT_CANVAS_SELECTION_CHANGED,
    EVENT_CLOSE_IMAGE_ACTION,
    EVENT_COPY_DOC_NOTE,
    EVENT_DELETE_HTML_NOTE,
    EVENT_NOTE_ON_SLIDER_RIGHT,
    EVENT_REFRESH_EDIT_CARD,
    EVENT_REFRESH_LIBRARY_LIST, EVENT_REFRESH_RECENTS, EVENT_REFRESH_SLIDER_INFO, EVENT_RENAME_LIBRARY_ITEM,
    EVENT_RESIZING_CARD,
    EVENT_SHOW_CONTEXT_MENU,
    EVENT_SYNC_NOTE_DATA, EVENT_SYNC_REFRESH_DRAW_CARDEDIT, EVENT_TEST_ONDRAG_NOTE,
    EVENT_UPDATE_CANVAS_NOTE_TO_DB,
    EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,
    EVENT_UPDATE_NOTE,
    EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD,
    EVENT_UPDATE_NOTE_HEIGHT, getElementSelectionBorderColor, getNoteElementBackgroundColor,
    LINK_INFO_TYPE_LIBRARY,
    LINK_INFO_TYPE_PROJECT,
    MAP_WEEK,
    MAP_WEEK_FULL,
    MARGIN_TOP_CONTENT, MAX_AUTO_CARD_EDIT_HEIGHT, MAX_IMAGE_FILE_SIZE,
    MAX_SIZE, MAX_Z_INDEX,
    MENU_SEPARATOR
} from "../../../../../src/Const";
import {
    batchCardHighlight,
    getCardById,
    getNoteById, getTiptapDoc,
    removeCardImage,
    updateCard,
    updateTiptapDoc
} from "../../../../../model";
import {imgServer} from "../../../../../src/components/EditorV2/imgServer";
import {postMessage, recvMessage, unSubscribe} from "../../../../../src/common/event";
import {KEYS} from "../../keys";
import Link from "../../../../../src/components/EditorV2/extension-link/src/index"

import global from "../../../../../src/global";
import {useTranslation} from "react-i18next";
import ImgAction from "../../../../../src/components/EditorV2/ImgAction";
import {APP_WEB} from "../../../../../src/electron_interactive";
import Background from 'tiptap-extension-background-color'
// import Youtube from "@tiptap/extension-youtube";
import Youtube from "../../../../../src/components/EditorV2/extension-youtube";
import HardBreak from "@tiptap/extension-hard-break";
import latexBlock from "../../../../../src/components/EditorV2/latexMath/latexBlock";
import 'katex/dist/katex.min.css'
import clipboard from "clipboardy";
import {getFontFamilyString, getFontString, sceneCoordsToViewportCoords} from "../../utils";
import * as model from '@model'
import img from "../../../../../src/components/EditorV2/imgs/colorPicker.png";
import {useAtom} from "jotai";
import {randomInteger} from "../../random";
import {mutateElement} from "../../element/mutateElement";
import ListKeymap from '@tiptap/extension-list-keymap'
import {PopupCardPlus} from "../../../../../src/components/Plus/PopupCardPlus";
import OrderedList from '@tiptap/extension-ordered-list'
import {
    handleBackspace,
    handleClipboard, handleShiftTab, handleTab,
    handleTransformPastedHTML,
    handleTransformPastedText
} from "../../../../../src/components/EditorV2/TiptapCommonHandle";
import latexInline from "../../../../../src/components/EditorV2/latexInline/latexInline";
import {getHeadingExtend} from "../../../../../src/components/EditorV2/EditorExtensions/HeadingExtend";
import {getListItemExtend} from "../../../../../src/components/EditorV2/EditorExtensions/ListItemExtend";
import {debugLog} from "../../../../../src/LogUtils";
import {getBubblletListExtend} from "../../../../../src/components/EditorV2/EditorExtensions/BulletListExtend";
import {ipcInvoke} from "../../../../../src/common/ipc";
import clsx from "clsx";
import {DEFAULT_FONT_SIZE, POINTER_EVENTS} from "../../constants";
import {HoveredElementCircle} from "../HoveredElementCircle/HoveredElementCircle";
import './StickyNoteTiptap.css'
import {
    getBoldExtension,
    getHyperlinkExtension,
    getItalicExtension, getStrikeExtension
} from "../../../../../src/components/EditorV2/TiptapTiptapExtension";
import { rotate } from "../../math";
import { getHoverHandles } from "../../element/resizeTest";

let timer:any = null

let mIsEditStatsUpdate:any = false;

//浮动菜单的最小宽度
const BUBBLUE_MENU_MIN_WIDTH = 360;

const HEIGHT_OFFSET = 0;
let TITLE_MARGIN_TOP = 0;
const CARD_EDIT_DRAG_ID_PRE = "card-edit-drag-handle-";

const mapDivScroll:any = {};

const MAX_CARD_HEIGHT = 800;

export const StickyNoteTiptapCache = new Map();

const StickyNoteTiptap = forwardRef((props:{app:any,state:any,element:any,updateElementCallback:any,onActionCallback:any,onMouseDown:any,onMouseMove:any,onMouseUp:any,onWheel:any,onTextSelection:any,isRender:any,onSelectionText?:any,onFocus?:any}, ref) => {
    const [pos, setPos] = useState<[boolean, number]>([false, 0]);
    const [isEditable, setIsEditable] = useState(false);
    const [isTitleHoverd, setIsTitleHoverd] = useState(false);
    const divContainerRef = useRef(null);
    const [isEnableEvents, setIsEnableEvents] = useState(true);

    const [isShowTextBar, setIsShowTextBar] = useState(true);
    const [hasTitle,setHasTitle] = useState(false);

    const mIsMouseDown = useRef(false);
    const mIsMoving = useRef(false);
    const mIsMoved = useRef(false);

    const [,updateState] = useState();
    const forceUpdate = React.useCallback(()=>updateState({}),[]);
    let mEditor = useRef<any>(null);
    const mEditorContentRef = useRef(null);
    //是否已经从数据库从新读取了....
    const mIsReadOk = useRef(false);

    const el = props.element;
    const appState = props.state;

    if (!props.element.customData){
        props.element.customData = {generationData:{}};
    }

    const importConfig = global.g_edit_md_token;
    const extensions = [
        StarterKit,
        // InlineCodeMark,
        CodeInlie,
        getListItemExtend('stickynote'),
        OrderedList.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    blockHighlight: {
                        default: false,
                    },
                    noteText: {
                        default: ''
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                };
            },
        }),
        getBubblletListExtend(),
        Youtube.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    highlightImgUrl: {
                        default: '',
                    },
                    noteText: {
                        default: ''
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                };
            },
        }),
        Export.configure(importConfig),
        Focus.configure({
            className: 'has-focus',
            mode: 'deepest',
        }),
        RenderCustomTable.configure({
            resizable: true,
            // allowTableNodeSelection: true,
        }),
        TableRow,
        TableHeader,
        CustomTableCell,
        ListKeymap,
        HardBreak.extend({
            addKeyboardShortcuts() {
                return {
                    "Mod-e":()=>{
                        //  2. 行内代码快捷键：在卡片中选中文字，windows点击ctrl+E，mac中点击cmd+E，就能将选中的文字转换为行内代码，参考notion，详见视频3
                        editor.chain().focus().toggleCode().run();
                        return true;
                    },
                    "Mod-k":()=>{
                        if (editor.state.selection.from != editor.state.selection.to){
                            showLink();
                        }else{
                            //显示全局的搜索.
                            window.showDialogGlobalSearch();
                        }
                    },
                    "Mod-Shift-e":()=>{
                        const selectedText = editor.state.doc.textBetween(
                            editor.state.selection.from,
                            editor.state.selection.to,
                            "\n"  // 节点分隔符
                        );
                        if (selectedText){
                            editor.commands.insertContent(`<latex-inline data-metaData="${selectedText}" data-firstCreate="true"></latex-inline>`)
                        }else{
                            editor.commands.insertContent(`<latex-inline data-firstCreate="true"></latex-inline>`)
                        }

                        return true;
                    },
                    "Mod-E":()=>{
                        //  2. 行内代码快捷键：在卡片中选中文字，windows点击ctrl+E，mac中点击cmd+E，就能将选中的文字转换为行内代码，参考notion，详见视频3
                        editor.chain().focus().toggleCode().run();
                        return true;
                    },
                    "Mod-K":()=>{
                        showLink();
                    },
                    "Mod-Shift-E":()=>{
                        const selectedText = editor.state.doc.textBetween(
                            editor.state.selection.from,
                            editor.state.selection.to,
                            "\n"  // 节点分隔符
                        );
                        if (selectedText){
                            editor.commands.insertContent(`<latex-inline data-metaData="${selectedText}" data-firstCreate="true"></latex-inline>`)
                        }else{
                            editor.commands.insertContent(`<latex-inline data-firstCreate="true"></latex-inline>`)
                        }

                        return true;
                    },

                    Enter: () => {
                        // const divCustomDrag = document.querySelector(".custom-drag-handle");
                        // if (divCustomDrag) {
                        //     divCustomDrag.style.display = "none";
                        // }
                        const { from, to } = mEditor.current?.state.selection;
                        const resolvedPos = mEditor.current?.state.doc.resolve(from);
                        // 获取当前节点
                        const currentNode = resolvedPos.node();
                        if (resolvedPos.parentOffset === 0 && currentNode.type.name === 'paragraph') {
                            setTimeout(() => {
                                const { from, to } = mEditor.current?.state.selection;
                                const resolvedPos = mEditor.current?.state.doc.resolve(from);
                                // 获取下一个节点
                                const node = resolvedPos.node();
                                let tempID = node.attrs.id
                                node.attrs.id = currentNode.attrs.id
                                currentNode.attrs.id = tempID
                                console.log('---77');

                            }, 100);
                        }
                        return false;
                    },
                    Backspace: () => {
                        return handleBackspace(mEditor.current,null);
                    },
                    Tab: () => {
                        return handleTab(mEditor.current);
                    },
                    'Shift-Tab': () => {
                        return handleShiftTab(mEditor.current);
                    }
                }
            }
        }),
        // Mathematics.configure({
        //     // regex: /\&\&([^\&]*)\&\&/gi
        // }),
        getHyperlinkExtension(),
        latexInline,
        latexBlock,
        UniqueID.configure({
            types: ['tableRow', 'taskList', 'paragraph','deeplink', 'image', 'blockquote', 'bulletList', 'orderedList', 'horizontalRule', 'youtube', 'table', 'highlight', 'latexBlock'],
            filterTransaction: transaction => {
                return !transaction.getMeta('preventUpdate')
            }
        }),
        Gapcursor,
        Focus.configure({
            className: 'has-focus',
            mode: 'deepest',
        }),
        Text,
        TextStyle,
        Color,
        getHeadingExtend('stickynote'),
        Paragraph.extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                };
            },
        }),
        Highlight.configure({ multicolor: true }).extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    id: {
                        default: crypto.randomUUID()
                    },
                    noteText: {
                        default: '',
                    },
                };
            },
            addCommands() {
                return {
                    ...this.parent?.(),
                    setHighlightId: (id,from) =>async  ({ tr, state, dispatch }) => {
                        await sleep(30)
                        const resolvedPos = this.editor.state.doc.resolve(from);
                        // 获取当前节点  实际id已经改变了，只是渲染的id值没变 重新渲染即可
                        const currentNode = resolvedPos.node().content.content[0];
                        currentNode.marks[0].attrs={...currentNode.marks[0].attrs,id:id}
                        return true;
                    }
                };
            }
        }),
        TextAlign.configure({
            types: ["heading", "paragraph"],
        }).extend({
            addKeyboardShortcuts() {
                return{
                    "Mod-Shift-e":()=>{
                        return false;
                    },
                    "Mod-Shift-E":()=>{
                        return false;
                    },
                }
            }
        }),
        Underline,
        getBlockMenu('stickynote'),
        PopupCardPlus,
        Placeholder.configure({
            placeholder: '',
        }),
        FontSize,
        Indent,
        Link.configure({
            protocols: ['noteey', 'noteeditor'],
            autolink: false,
            linkOnPaste: false,
            openOnClick: true
        }).extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                }
            }
        }),
        ImageT,
        Background,
        Image.configure({
            allowBase64: true
        }),
        SearchNReplace.configure({
            searchResultClass: "search-result", // class to give to found items. default 'search-result'
            caseSensitive: false, // no need to explain
            disableRegex: false, // also no need to explain
        }),
        ImagePaste.configure({
            fileMatchRegex: /^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i,
            disableImagePaste: false,
            render: () => {
                return {
                    onImagePaste: files => {
                        files.forEach(file => {
                            if (file.size > MAX_IMAGE_FILE_SIZE){
                                const id = crypto.randomUUID();
                                const szFileName = id +'.' + extFromMineType(file.type);
                                ipcInvoke('resize-image-file',{filePath:file.path,name:szFileName,type:file.type,toLocal:true})?.then((szFilePath)=>{
                                    mEditor.current?.chain().focus().setImage({src: 'atom://' +szFileName}).run()
                                    mEditor.current?.commands.blur()
                                })
                            }else{
                                fileToBase64(file).then(r => {
                                    const id = crypto.randomUUID();
                                    model.addImg(id, r)
                                    mEditor.current?.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
                                    mEditor.current?.commands.blur()
                                })
                            }
                        });
                    },
                    onDisabledImagePaste: text => {
                        console.log('text: ', text);
                        // add text to editor if you want, or display an error/upselll message
                    },
                    onImageDrop: files => {
                        files.forEach(file => {
                            fileToBase64(file).then(r => {
                                const id = crypto.randomUUID();
                                model.addImg(id, r)
                                mEditor.current?.chain().focus().setImage({src: 'atom://' + id + '.jpeg'}).run()
                                mEditor.current?.commands.blur()
                            })
                        });
                    },
                };
            },
        }),
        TaskList.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    blockHighlight: {
                        default: false,
                    },
                    noteText: {
                        default: ''
                    },
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                };
            },

        }),
        TaskItem.configure({
            nested: true,
        }),
        HorizontalRule.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                };
            },
        }),
        Blockquote.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    }
                };
            },
        }),
        // Hyperlink.configure({}),
        FontFamily,
        CodeBlockLowlight.extend({
            addNodeView() {
                return ReactNodeViewRenderer(CodeBlockComponent);
            },
            addAttributes() {
                return {
                    ifhidden: {
                        default: false,
                        renderHTML: attributes => {
                            if (attributes.ifhidden === undefined) {
                                return {};
                            }
                            return {
                                'ifhidden': attributes.ifhidden,
                            };
                        },
                    },
                    language: {
                        default: 'Auto'
                    }
                };
            }
        }).configure({lowlight}),
        DeeplinkNode.configure({
            fontSize: '15px',
            marginTopImg:'3.5px',
            containerMarginTop:'-1px'
        }),
        getBoldExtension(),
        getItalicExtension(),
        getStrikeExtension()
    ]

    let editor = useEditor({
        autofocus: false,
        injectCSS: true,
        editable: true,
        extensions: extensions,
        editorProps: {
            attributes: {
                // class: '',
            },
            handleDOMEvents:{
                keydown:(view,event)=>{
                    if (event.key == '@'){
                        window.showPopupCardList(mEditor.current);
                    }else if (event.key == KEYS.BACKSPACE){
                        window.closePopupCardList();
                    }
                },
                dragstart:(view,event)=>{
                    event.preventDefault();
                    event.stopPropagation();
                },
            },
            clipboardTextParser(text, context, plain, view) {
                if (mEditor.current) {
                    return handleClipboard(mEditor.current,text);
                }
            },
            transformPastedText(text, plain, editorView) {
                return handleTransformPastedText(text, plain, editorView);
            },
            transformPastedHTML(html,editorView) {
                return handleTransformPastedHTML(html,editorView,props.element.id)
            },
            handleClick(e, r, k) {
                if (!props.element?.customData?.generationData?.isEditable)return;

                //取消选中
                mEditor.current.chain().focus().setTextSelection(r).run();

                //记录点击的位置
                const divScroll = document.getElementById('div-cardedit-scroll-'+props.element.id);
                global.g_mapCardPos[props.element.id] = {pos:r,scroll:divScroll?.scrollTop || 0};

                postMessage(EVENT_CLOSE_IMAGE_ACTION);
                window.closePopupCardList();
            },
        },
        onUpdate(editor0) {
            if (!mEditor.current){
                mEditor.current = editor0.editor;
            }

            let tempArr:any = []
            let reverseInlineLatexArr:any = []
            mEditor.current.state.doc.descendants((node, pos) => {
                if (node.type.name === "paragraph" && node.content) {
                    const content = node.content.content; // ProseMirror Node 的子节点数组在 content.content 里

                    for (let i = 0; i < content.length - 1; i++) {
                        const current = content[i];
                        const next = content[i + 1];
                        if (
                            current.type.name === "latexInline" && current.attrs?.dollarBoundaries===1 &&
                            next.type.name === "text" &&
                            /^\d/.test(next.text || "")) {
                            tempArr.push(current)
                        }
                    }
                } else if (node.type.name === "latexInline" && tempArr?.[0]?.attrs?.id === node.attrs.id) {
                    reverseInlineLatexArr.push({
                        node: node,
                        pos: pos
                    })
                    tempArr.shift()
                }
            });
            if (reverseInlineLatexArr.length > 0) {
                for (let i = 0; i < reverseInlineLatexArr.length; i++) {
                    const element = reverseInlineLatexArr[i];
                    const textNode = mEditor.current.state.schema.text(`$${element.node.attrs.metaData}$`);

                    // 用 replaceWith 把原来的节点替换掉
                    const tr = mEditor.current.state.tr.replaceWith(element.pos, element.pos + element.node.nodeSize, textNode);
                    mEditor.current.view.dispatch(tr);
                }
            }

            let html = imgServer.parserImgFromHtml(editor?.getHTML() as string,props.element.id);
            if (mIsReadOk.current){
                // console.log('****************onUpdate****************isEditable')
                mutateElement(props.element,{value:html});
                //保存到单独的表...
                updateTiptapDoc({id:props.element.id,doc:html});
            }

            if (!mIsEditStatsUpdate) {
                if (timer) clearTimeout(timer)
                timer = setTimeout(() => {
                    if (editor) {

                        /** 最后为图片时， 作为p标签 */
                        if (/\<img[^\>]+\>$/.test(html)) {
                            editor?.commands.setContent(html + '<p></p>')
                        }
                    }
                }, 500)

                updateElementHeight('', 'tiptap');
                if (global.g_isDrawCardUpdate) {
                    updateEditCard();
                    global.g_isDrawCardUpdate = false;
                }

            }
            mIsEditStatsUpdate = false;
        },
        onSelectionUpdate(editororororororor) {
            const editor = editororororororor.editor;
            const { from, to } = editor.state.selection;
            if (!props.element.customData?.generationData?.isEditable){
                setTimeout(()=>{
                    onHiddenBubbleMenu()
                },10)

                return;
            }

            const selectNode:any = []
            editor.state.doc.nodesBetween(from, to, (node, pos) => {
                // console.log('---node--', node);

                selectNode.push({
                    nodeType: node.type.name,
                })
            });
            // console.log('selectNode', selectNode);

            if (selectNode.length > 1 || (selectNode.length === 1 && selectNode[0].nodeType !== 'image')) {
                setIsShowTextBar(true);

            } else if (selectNode.length === 1 && selectNode[0].nodeType === 'image') {
                setIsShowTextBar(false);
            }

            let szName = editor.state.selection.node?.type?.name;
            if (props.onSelectionText){
                props.onSelectionText(to !== from);
            }
            if ('deeplink' == szName || to == from){
                onHiddenBubbleMenu();
            }else{
                const szTxt = editor.state.doc.textBetween(from,to);
                props.onTextSelection(!isStringNullOrEmpty(szTxt),editor,updateEditCardHtml,null,props.element,null,onHiddenBubbleMenu,onAction);
                if (window.updateBubblePosition){
                    window.updateBubblePosition();
                }
            }

            if (from != to){
                global.g_currentSelectedText = editor.state.doc.textBetween(from,to);
                window.globalCardEditSelected = async ({x,y})=>{
                    const item = {
                        createTime:Date.now(),
                        doc:'',
                        id:generateUUID2(),
                        name:global.g_currentSelectedText,
                        tags:[],
                        type:'card',
                        updateTime:Date.now()
                    }
                    await updateCard(item);
                    const szLink = createCopyLink('library',item.id,'card',null,null,null,false)
                    //2.添加链接
                    editor.commands.setLink({href: szLink, target: '_blank'});
                    postMessage(EVENT_TEST_ONDRAG_NOTE,{...item,x:x,y:y})
                }
            }
        },
        onCreate(editor0) {
            console.log('onCreate')
            mEditor.current = editor0.editor;
            StickyNoteTiptapCache.set(props.element.id,mEditor.current);
            editor0.editor.id = props.element.id;
            // const data = preserveWhitespace(props.element.value);
            // editor0.editor.commands.setContent(data);
            refreshData();
            //第一个是项目符号表的时候设置数据会报错--第一个是项目符号表的时候设置数据会报错--第一个是项目符号表的时候设置数据会报错
            // editor0.editor.commands.setContent(data,false,{preserveWhitespace:'full'});//不能这设置，从哪里复制来的后面2个参数？？？不能这设置，从哪里复制来的后面2个参数？？？不能这设置，从哪里复制来的后面2个参数？？？不能这设置，从哪里复制来的后面2个参数？？？不能这设置，从哪里复制来的后面2个参数？？？不能这设置，从哪里复制来的后面2个参数？？？

            // editor0.editor.commands.setTextSelection(0);
            // editor0.editor.view.dom.classList.remove('ProseMirror');
            editor0.editor.view.dom.classList.add('ProseMirror-card');
            editor0.editor.view.dom.classList.add('ProseMirror-editor-text-item');
            editor0.editor.view.dom.style.marginTop = '';
            // editor0.editor.view.dom.style.height = 'calc(100% - 32px)';//props.element.height+'px';
            editor0.editor.view.dom.style.color = 'inherit'
            // editor0.editor.view.dom.style.overflow='auto';
            // editor0.editor.view.dom.style.setProperty('margin','16px 0px','important');
            editor0.editor.view.dom.style.setProperty('padding','16px 16px','important');

            editor0.editor.isShowSliderTip = true;//显示侧栏提示
            editor0.editor.forceUpdate = ()=>{
                updateEditCard();
            }

            editor0.editor.view.dom.onwheel = (event) => {
                if (event.ctrlKey || event.metaKey) {
                    props.onWheel(event);
                }
            };

            //第一次，根据element的高度调整一次内容的高度..
            // const nElementHeight = props.element.height;
            // console.log('****根据element的高度:'+nElementHeight);
            // if (divContainerRef.current) {
            //     divContainerRef.current.style.height = (nElementHeight - DEFAULT_TOOLBAR_HEIGHT - 20 - HEIGHT_OFFSET) + 'px'
            // }

            if (appState.selectedElementIds[el.id]){
                setCardIsEditable();
                window.showCanvasFolatMenu();
            }
        },
        onFocus(editor){
          // console.log('fffffooooocccccccccccccuuuuuuuuusssss');
            if (props.onFocus){
                props.onFocus();
            }
        },
        onBlur(editor) {
            console.log('onblur............................updateEditCard...');
            if (!global.g_isImageActionMouseDown) {
                postMessage(EVENT_CLOSE_IMAGE_ACTION);
            }
            global.g_isImageActionMouseDown = false;
            props.element.customData.generationData.isEditable = (appState.selectedElementIds[el.id] != undefined);
            setIsEditable(props.element.customData.generationData.isEditable);
            if (!props.element.customData.generationData.isEditable){
                global.g_currentCardEditor = null;
                global.g_currentCardEditElement = null;
            }

            updateEditCardHtml();
            props.app.pushHistory();
            //刷新左侧栏.
            if (window.onRefreshSingleElement){
                window.onRefreshSingleElement(props.element);
            }
            // onHiddenBubbleMenu();
        },
        onDestroy() {
            // console.log('onDestroy   xxxxx');
            // updateEditCard();
        },
        parseOptions: {
            preserveWhitespace: 'full',
        },
    });
    editor.from = 'STICKY_NOTE_TIPTAP'
    /**
     * 隐藏这个固定的菜单
     */
    const onHiddenBubbleMenu = ()=>{
        // const { from, to } = mEditor.current.state.selection;
        // mEditor.current.commands.setTextSelection(from);
        props.onTextSelection(false,null,null,null,null,null,null,null)
    }

    const updateEditorOverflowState = ()=>{
        // if (mEditor.current){
        //     mEditor.current.view.dom.style.overflow= props.element.customData.generationData.isEditable?'auto':'hidden';
        // }
    }

    const onAction = (data)=>{
        if (data == 'h1Changed'){
            refreshH1Title();
        }
    }

    /**
     * 更新拖动的可见状态
     */
    const updateCardDragVisible = () => {
        const divCustomDrag = document.getElementById(CARD_EDIT_DRAG_ID_PRE + props.element.customData.generationData.id);
        if (divCustomDrag) {
            if (props.element.customData.generationData.isEditable) {
                divCustomDrag.style.visibility = "visible";
            } else {
                divCustomDrag.style.visibility = "hidden";
            }

            // console.log(document.querySelector('.excalidraw__embeddable-container').style.transform.scale)
            // let x = props.element.width - props.element.width * global.g_canvasZoomValue;
            // let y = props.element.height - props.element.height * global.g_canvasZoomValue;

            // divCustomDrag.style.transform = `translate(${-40}px, ${-100}px) scale(${global.g_canvasZoomValue})`
        }
    }

    /**
     * 刷新这个元素的高度
     * @param szId
     */
    const refreshElementHeight = (szId)=>{
        if (props.element.id == szId){
            setTimeout(()=>{
                updateElementHeight('','tiptap');
            },100)
        }
    }

    /**
     * 更新高度
     */
    const updateElementHeight = (szNewHtml = '', from: any) => {
        if (global.g_isPresentMode) return;
        if (editor == null) return;
        // if (!props.element.customData.generationData.isEditable)return;

        if (!props.element.customData.generationData.isFixedSize) {
            //没有调整过大小，自动高度...
            let height = editor?.view.dom.clientHeight;
            if (height < DEFAULT_STICK_NOTE_HEIGHT){
                height = DEFAULT_STICK_NOTE_HEIGHT;
            }
            if (height > document.body.clientHeight*0.7) {
                height =  document.body.clientHeight*0.7;
            }
            let eleHeight = height;

            if (divContainerRef.current){
                divContainerRef.current.style.height = (eleHeight) + 'px';
            }

            mutateElement(props.element,{height:eleHeight});
            const ele = props.app.getSceneElements().find(p=>p.id == props.element.id);
            if (ele){//不多加一个又TM改不动。。。。--发现在个react 还是有点🤢
                mutateElement(ele,{height:height});
            }
            // mEditor.current.view.dom.style.setProperty('height',`${eleHeight}px`);

            // if (szNewHtml) {
            //     props.element.customData.generationData.html = imgServer.parserImgFromHtml(szNewHtml);
            // }
            //
            if (props.updateElementCallback) {
                props.updateElementCallback(props.element, {height: eleHeight})
            }
        } else {
            setTimeout(() => {
                if (divContainerRef.current) {
                    divContainerRef.current.style.height = (props.element.height) + 'px';
                    if (props.updateElementCallback) {
                        props.updateElementCallback(props.element, {height: props.element.height})
                    }
                }
            }, 300);
        }
    }

    useEffect(() => {

        if (props.element) {
            // if (props.element.customData.generationData.isExpand == undefined) {
            //     props.element.customData.generationData.isExpand = true;//没有的默认为展开状态...
            //     props.element.customData.generationData.isFixedSize = true;//默认为固定大小
            // }
            props.element.customData.generationData.isEditable = false;
        }


        const handleBlockLinkClick = (event) => {
            if (props?.data?.id === event?.detail?.noteId && props?.data?.id !== undefined) {
                // 直接跳转
                const selectedNP = editor.$doc.querySelectorAll(event.detail.blockType, { id: event.detail.blockId })[0]
                editor.chain().blur().setNodeSelection(selectedNP.pos - 1).scrollIntoView().run();
                // let els = document.querySelector(`.ProseMirror [data-id="${event.detail.blockId}"]`)
                // console.log(1212,els?.outerHTML);
                // debugger
                // els?.scrollIntoView({ block: 'start' })
            } else {
                // 关闭当前弹窗后跳转
                document.dispatchEvent(new CustomEvent('outsideBlockLinkClick', {
                    detail: {
                        noteId: event.detail.noteId,
                        blockId: event.detail.blockId,
                        blockType: event.detail.blockType
                    }
                }))
            }
        }
        document.addEventListener('blockLinkClick', handleBlockLinkClick);

        return ()=>{
            unSubscribe(EVENT_SYNC_REFRESH_DRAW_CARDEDIT);
            document.removeEventListener('blockLinkClick', handleBlockLinkClick);
        }

    }, [])

    useEffect(()=>{
        refreshH1Title();
    },[hasTitle])

    /**
     * 按键
     * @param event
     */
    function onKeyDown(event:any){
        // debugLog('actionProperties',event);
        if (event.key == KEYS.ESCAPE){
            window.closePopupCardList();
        }
    }

    useEffect(() => {
        //激活...
        recvMessage(EVENT_ACTIVE_CARD_EDIT, (msg, data) => {
            if (data.data.id == props.element.id) {
                editor?.commands.focus();
            }
        })


        document.body.addEventListener('keydown',onKeyDown);


        window.refreshList['refresh-element-height_'+props.element.id] = refreshElementHeight;

        return () => {
            unSubscribe(EVENT_ACTIVE_CARD_EDIT);
            unSubscribe(EVENT_REFRESH_EDIT_CARD);
            unSubscribe(EVENT_RESIZING_CARD);
            unSubscribe(EVENT_UPDATE_CANVAS_NOTE_TO_DB);
            unSubscribe(EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO);
            document.body.removeEventListener('keydown',onKeyDown);
            delete window.refreshList['refresh-element-height_'+props.element.id];
            // unSubscribe(EVENT_CANVAS_SELECTION_CHANGED)
        }
    });

    useEffect(() => {
        //这🤢玩意，latexblock从弹窗中不会更新？？？必须置空一下。。。。
        // editor?.commands.setContent('');
        try{
            // const szContent = migrateInlineCodeToOfficial(preserveWhitespace(props.element.value));
            // editor?.commands.setContent(szContent);
            refreshData();
        }catch (e) {
            console.log(e);
        }

        setIsEditable(props.element.customData.generationData.isEditable);

        recvMessage(EVENT_CANVAS_SELECTION_CHANGED, (msg, data) => {
            // console.log("setIsEnableEvents   " + Object.keys(data.data.selectedElements).length)
            setIsEnableEvents(Object.keys(data.data.selectedElements).length <= 1);
        })

        // setTimeout(()=>{
        //     window.hookATags();
        // },500);

        window.refreshList['on_update_html_'+props.element.id] = onUpdateHtml;


        return ()=>{
            unSubscribe(EVENT_CANVAS_SELECTION_CHANGED);
            unSubscribe(EVENT_CANVAS_EXPAND_STATS_CHANGED);
            unSubscribe(EVENT_SYNC_REFRESH_DRAW_CARDEDIT);
            delete window.refreshList['on_update_html_'+props.element.id];
        }

    }, [props.element.id]);


    useEffect(() => {
        setTimeout(() => {
            editor?.setEditable(props.element.customData.generationData.isEditable);
            // editor?.commands.setTextSelection(-1);
            if (!props.element.customData.generationData.isEditable){
                onHiddenBubbleMenu();
                try {
                    document.querySelectorAll('.drag-handle').forEach((el: any) => el.classList.add('hide'));
                } catch (e) {}
            }
        }, 10)
        updateEditorOverflowState();
    }, [props.element.customData.generationData.isEditable])

    useEffect(() => {
        if (divContainerRef.current) {
            divContainerRef.current.style.height = (props.element.height) + 'px';
        }
    }, [props.element.height])

    /**
     * 这里从数据库也刷新一遍数据...
     */
    function refreshData(){
        getTiptapDoc(props.element.id).then(res=>{
            if (res){
                if (props.element.id != res?.id) {
                    mIsReadOk.current = true;
                    return;
                };

                mutateElement(props.element,{value:res.doc});
                const szContent = migrateInlineCodeToOfficial(preserveWhitespace(res.doc));
                editor?.commands.setContent(szContent);
            }else{
                const szContent = migrateInlineCodeToOfficial(preserveWhitespace(props.element.value));
                editor?.commands.setContent(szContent);
                //保存到独立表.
                updateTiptapDoc({id:props.element.id,doc:szContent});
            }

            updateElementHeight('', 'tiptap');
            mIsReadOk.current = true;
        })
    }

    // 将普通空格替换为 &nbsp;，换行替换为 <br> 或使用段落
    function preserveWhitespace(html) {
        // 保留多个连续空格
        html = html.replace(/  /g, ' &nbsp;');

        // 保留换行符 - 方法1: 替换为 <br>
        // html = html.replace(/\n/g, '<br>');

        // 保留换行符 - 方法2: 替换为段落（更语义化）
        html = html.replace(/\n/g, '</p><p>');

        return html;
    }

    //强制刷新主题--这里还要切换背景和内容颜色。
    function forceRefreshSelf(){
        if (isDefaultBackgroundColor(props.element.backgroundColor)) {
            props.element.backgroundColor = getNoteElementBackgroundColor();

            const ele = props.app.getSceneElements().find(p=>p.id == props.element.id);
            mutateElement(ele,{backgroundColor:getNoteElementBackgroundColor()})
        }

        forceUpdate();
    }

    function refreshH1Title(){
        if (mEditor.current){
            if (!hasTitle){
                if (mEditor.current.view.dom.firstChild.classList.contains('heading-container') && mEditor.current.view.dom.firstChild.innerHTML.includes('h1')){
                    mEditor.current.view.dom.style.marginTop = '-9px';
                    mEditor.current.view.dom.firstChild.style.marginBottom = '15px';
                }else{
                    mEditor.current.view.dom.style.marginTop = '';
                }
            }else{
                mEditor.current.view.dom.style.marginTop = '';
            }
        }
    }

    const onUpdateHtml = (szHtml)=>{
        mEditor.current?.commands.setContent(szHtml);
        setTimeout(()=>{
            updateElementHeight();
        },100)
    }

    /**
     * sliderDraw 给draw 发送消息
     * @param szAction
     * @param data
     */
    const sendMessageFromSliderDraw = (szAction,data)=>{
        window.parent.postMessage({action:szAction,data:data})
    }

    /**
     * draw 给 sliderDraw发消息
     * @param szAction
     * @param data
     */
    const sendMessageFromDraw = (szAction,data)=>{
        const iframe = document.getElementById('iframe-slider-drawindex-container');
        if (iframe){
            iframe.contentWindow.postMessage({action:szAction,data:data})
        }
    }

    /**
     * 更新卡片
     */
    const updateEditCard = (szTitle:any,bSaveDb = true) => {

    }

    /**
     * 只更新html
     */
    const updateEditCardHtml = ()=>{
        const doc = imgServer.parserImgFromHtml(editor?.getHTML() as string,props.element.id);
        props.element.customData.generationData.html = doc;

        //更新一下，标记有更新。。。。
        props.app.signUpdateElement(props.element.id,{versionNonce:randomInteger()})
    }

    //空白地方插入p
    function onEditDivClick(e) {
        setTimeout(() => {
            const selection2 = window.getSelection()
            if (selection2?.type === 'Range' && pos[0]) {
                editor?.commands.focus(pos[1])
                setPos([false, 0])
            }

            let html = editor?.getHTML()
            /** 最后为图片时， 作为p标签 */
            if (!/\<\/p\>$/.test(html)) {
                editor?.commands.setContent(html + '<p></p>')
            }
        }, 10)
    }


    /**
     * 卡片点击编辑
     */
    function onCardClick(){
        // console.log('oncard-click');
        if (!props.element.customData.generationData.isEditable /*&& !mIsMoving.current*/) {//这个控制是啥？不知道什么用，取消了。。。20250320//
            setCardIsEditable();
        }
        mIsMoving.current = false;
        global.g_isCanvasCardMouseDown = false;
    }

    /**
     * 设置卡片可编辑
     */
    function setCardIsEditable() {
        if (global.g_isPresentMode) return;
        if (props.element.locked)return;
        if (mIsMoved.current)return;//有过移动.

        global.g_isDrawCardEditing = true;

        mIsEditStatsUpdate = true;
        props.element.customData.generationData.isEditable = true;
        setIsEditable(props.element.customData.generationData.isEditable);
        editor?.setEditable(props.element.customData.generationData.isEditable);
        if (document.activeElement?.id != props.element.id){
            //非标题激活...
            editor?.commands.focus();
            setTimeout(()=>{
                //只选中一个..
                editor.chain().setTextSelection(editor.state.selection.from).run();

            },100)
        }

        //更新这个element....
        // const customData = {...props.element.customData};
        // props.updateElementCallback(props.element, {customData: customData})

        updateCardDragVisible();

        //更新全局的这个.....
        global.g_currentCardEditElement = props.element;
        global.g_currentCardEditor = editor;

        //选中位置
        // if (props.element.customData.generationData.isEditable && global.g_mapCardPos[props.element.id]){
        //     const possss = global.g_mapCardPos[props.element.id];
        //     setTimeout(()=>{
        //         const divScroll = document.getElementById('div-cardedit-scroll-'+props.element.id);
        //         if (divScroll){
        //             divScroll.scrollTo(0,possss.scroll);
        //         }
        //     },10)
        //
        //     setTimeout(()=>{
        //         mEditor.current.commands.setTextSelection(possss.pos);
        //     },50)
        // }
    }


    const showLink = ()=>{
        const text = editor.state.selection.content()?.content?.content?.[0]?.textContent;
        global.g_newCardTitle = text;

        let link = editor.getAttributes('link').href

        // window.showDialogCardLink({link, text}, (r: any) => {
        //     if (r?.delete) {
        //         editor.commands.unsetLink()
        //         // editor.commands.unsetHyperlink()
        //     } else if (r) {
        //         editor.commands.setLink({href: r.link, target: '_blank'})
        //         // editor.commands.setHyperlink({href: r.link, target: '_blank'})
        //     }
        //
        //     updateEditCardHtml();
        //     props.app.pushHistory();
        // })
        //关闭editor的焦点，以防止粘贴图片到库中的问题。。。
        mEditor.current?.commands.blur();

        window.showDialogLink(link, 'card', (item) => {
            if (!item) {
                editor.commands.unsetLink()
                // editor.commands.unsetHyperlink()
            } else {
                editor.commands.setLink({href: item, target: '_blank'})
            }
            setTimeout(() => {
                window.hookATags();
            }, 600)

            updateEditCardHtml();
            props.app.pushHistory();
        })
    }

    const { x, y } = useMemo(
        () =>
            sceneCoordsToViewportCoords({ sceneX: el.x, sceneY: el.y }, appState),
        [appState, el.x, el.y],
    );

    let isActive =
        appState.activeStickyNotes?.element?.id === el?.id &&
        appState.activeStickyNotes?.state === "active"

    //判断是否有选中---没有焦点的时候，移走了。
    if (!appState.selectedElementIds[el.id] && el?.customData?.generationData?.isEditable){
        setIsEditable(false);
        el.customData.generationData.isEditable = false;
    }

    const getFontFamily = ()=>{
        let fontFamily = '';
        if (!props.element.fontFamily){
            fontFamily = '"Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"';
        }else{
            fontFamily = `${getFontFamilyString({fontFamily: props.element.fontFamily})}`;
        }
        return fontFamily;
    }

    const shouldProxyHoverHandleEventToCanvas = (event: React.MouseEvent) => {
        // When sticky note is editable, the tiptap layer captures pointer events. If the user is
        // interacting with the hover-handle (blue dot), proxy the event to the canvas handlers.
        if (!isEditable) return false;
        try {
            const scenePointer = viewportCoordsToSceneCoords(event as any, props.state as any);
            const element: any = props.element;
            const centerX = element.x + element.width / 2;
            const centerY = element.y + element.height / 2;
            const [pointerX, pointerY] = rotate(
                scenePointer.x,
                scenePointer.y,
                centerX,
                centerY,
                -element.angle,
            );
            const hoverHandles = getHoverHandles({
                element,
                appState: props.state as any,
                size: 18,
            }) as any;
            return Object.values(hoverHandles).some((h: any) => {
                if (!h) return false;
                const range = [h.x, h.y, h.x + h.width, h.y + h.height];
                return (
                    pointerX > range[0] &&
                    pointerX < range[2] &&
                    pointerY > range[1] &&
                    pointerY < range[3]
                );
            });
        } catch {
            return false;
        }
    };

    /**
     * 边框颜色
     */
    const getBorderColor = ()=>{
        if (props.state.selectedElementIds[props.element.id]){
            return getElementSelectionBorderColor();
        }
        return el.customData?.generationData?.isShowBorder ?'rgba(0, 0, 0, 0.2)':'transparent'
    }

    return <div
        className={clsx("excalidraw__embeddable-container")}
        id={`excalidraw__embeddable-container${el.id}`}
        style={{
            transform: `translate(${x - appState.offsetLeft}px, ${y - appState.offsetTop
            }px) scale(${appState.zoom.value})`,
            display: "block",
            opacity: el.opacity / 100,
        }} onMouseDown={(e)=>{
        if(props.app.getSelectedElements().filter(p=>p.id != props.element.id).length >= 1) return;
        if (e.ctrlKey || e.metaKey){
            let isCtrl = true;
            global.g_isCtrlPressed = isCtrl;
            //打开编辑...
            window.showDialogTiptapTextEditorView(props.element);
            setTimeout(()=>{
                global.g_isCtrlPressed = false;
            },2000);
        }
    }}>
        <div
            className="excalidraw__embeddable-container__inner"
            id={`excalidraw__mindmap-container__inner${el.id}`}
            style={{
                width: `${el.width}px`,
                height: `${el.height}px`,
                transform: `rotate(${el.angle}rad)`,
            }}>
            <div
                className="excalidraw__embeddable__outer"
                id={`excalidraw__mindmap__outer${el.id}`}
                style={{
                    marginRight:'0px',
                    // height: `${el.height}px`,
                    pointerEvents: isActive
                        ? POINTER_EVENTS.enabled
                        : POINTER_EVENTS.disabled,
                }}>
                <div className={'div-stickynote-placeholder'} id={'stickynote-container-' + props.element.id} style={{
                    textAlign: "left",
                    height: '100%',
                    width: '100%',
                    marginTop: '0px',
                    // marginLeft: '-0.25px',
                    // marginRight: '-0.6px',
                    zIndex: '2006',
                    // overflow: props.element.customData.generationData.isExpand?'visible':'hidden',
                    borderRadius:'8px',
                    background: props.element.backgroundColor,
                    cursor: isEditable ? 'auto' : 'pointer',
                    pointerEvents: isEnableEvents ? 'all' : 'none',
                    padding:'0 2px',
                    boxShadow:`inset 0 0 0 2px ${getBorderColor()}`,
                    minHeight: props.element.customData.generationData.isExpand ? (DEFAULT_TOOLBAR_HEIGHT) + 'px' : `${DEFAULT_COLLAPSE_HEIGHT_1}px`
                }}
                     onClick={(e) => {
                         onEditDivClick(e);
                     }}
                     onMouseDown={(event) => {
                         mIsMoved.current = false;
                         const shouldProxy = shouldProxyHoverHandleEventToCanvas(event);
                         if (!isEditable || shouldProxy) {
                             if (shouldProxy) {
                                 event.preventDefault();
                                 event.stopPropagation();
                             }
                             mIsMouseDown.current = true;
                             props.onMouseDown(event);
                         }
                         // mOffset.current.x = event.clientX;
                         // mOffset.current.y = event.clientY;

                     }} onMouseMove={(event) => {
                    const shouldProxy = shouldProxyHoverHandleEventToCanvas(event);
                    if (!isEditable || mIsMouseDown.current || shouldProxy) {
                        props.onMouseMove(event);

                        if (mIsMouseDown.current) {
                            mIsMoving.current = true;
                            mIsMoved.current = true;
                        }
                    }
                    // updateCardDragVisible();
                }} onMouseUp={(event) => {
                    if (!isEditable || mIsMouseDown.current) {
                        props.onMouseUp(event);
                    }
                    mIsMouseDown.current = false;
                }} onDoubleClick={() => {
                    // setCardIsEditable()
                }} onMouseEnter={() => {
                    setIsTitleHoverd(true)
                }} onMouseLeave={() => {
                    setIsTitleHoverd(false)
                }} onWheel={(event) => {

                    let hasScrollView = false;
                    const divMain = document.getElementById('div-cardedit-scroll-' + props.element.id);
                    if (divMain && isEditable) {
                        hasScrollView = divMain.scrollHeight > divMain.clientHeight;
                    }
                    if (!hasScrollView) {
                        props.onWheel(event);
                    }
                }}>
                    <div ref={divContainerRef}
                         className={'div-placeholder stickynotetiptap ' /*+ ((props.element.customData.generationData.isEditable)?'':'scrollbar-transparent')*/}
                         id={'div-cardedit-scroll-' + props.element.id}
                         onScroll={(event) => {
                             console.log('xxxxxxxxx');
                             // if (!props.element?.customData?.generationData?.isEditable) {
                             //     event.preventDefault();
                             //     event.currentTarget.scrollTop = (mapDivScroll[props.element.id] || 0);
                             // }else {
                             //     mapDivScroll[props.element.id] = event.currentTarget.scrollTop;
                             // }

                             // postMessage(EVENT_CLOSE_IMAGE_ACTION);
                         }}
                         onMouseDown={(event) => {
                             global.g_isCanvasCardMouseDown = true;
                         }}
                         onDoubleClick={() => {
                             onCardClick();
                         }}

                         style={{
                             overflow: props.element.customData.generationData.isEditable ? 'auto' : 'hidden',
                             zIndex: '2006',
                             height: '100%',
                             clipPath:'inset(16px 0px 6px 0px)',
                             scrollbarColor: 'transparent',
                             paddingLeft:'6px',//修正那么一小点点偏移...
                             scrollbarGutter: 'stable'  //这个属性很重要，使滚动条提前占位！！！！！！！！！滚动条滚动条滚动条滚动条滚动条滚动条滚动条滚动条
                         }}>


                        <EditorContent ref={mEditorContentRef} id={'editcontent-' + props.element.id} className="tableStyle katex"
                                       style={{
                                           padding: '0px 0px',
                                           // marginBottom: '16px',
                                           textAlign: 'left',
                                           fontSize: `${props.element.fontSize}px`,
                                           color: `${props.element.strokeColor}`,
                                           fontFamily: getFontFamily()
                                       }} editor={editor}/>

                        <ImgAction editor={editor}/>
                    </div>
                </div>
            </div>

            {/*<div style={{*/}
            {/*    width: '100%', height: `100%`, left: '0', top: '0', position: 'absolute', zIndex: '1000',*/}
            {/*    border: (props.state.selectedElementIds[props.element.id]) ? `${2.2 / props.state.zoom.value}px solid ${getElementSelectionBorderColor()}` : 'none',*/}
            {/*    borderRadius: '8px', pointerEvents: 'none'*/}
            {/*}}></div>*/}

        </div>


        {/*//四个hoverd点*/}
        <HoveredElementCircle state={props.state} el={props.element}/>
    </div>

})

export default React.memo(StickyNoteTiptap);

















